import React from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from'@mui/material/TableHead';
import Typography from '@mui/material/Typography';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function ASSIGNARTimesheetsEmployeeTable({ name, totalHours, employeeData }) {
  const [open, setOpen] = React.useState(false);

  return (
    <>
    <TableContainer component={Paper} sx={{fontFamily: 'Montserrat'}}>
      <TableRow>
        <TableCell>
          <IconButton aria-label="expand row" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" sx={{fontFamily: "Montserrat", fontWeight: "600", width: "50%"}}>{name}</TableCell>
        <TableCell sx={{fontFamily: "Montserrat", fontWeight: "600", width: "50%"}}>{totalHours} </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <TableContainer component={Paper}>
                <Table sx={{ width: "100%" }} aria-label="simple table">
                  <TableHead>
                  <TableRow>
                    <TableCell component="th" scope="row" sx={{fontFamily: "Montserrat", fontWeight: "600"}}>
                      Date
                    </TableCell>
                    <TableCell sx={{fontFamily: "Montserrat", fontWeight: "600"}}>Start Time</TableCell>
                    <TableCell sx={{fontFamily: "Montserrat", fontWeight: "600"}}>Break Time</TableCell>
                    <TableCell sx={{fontFamily: "Montserrat", fontWeight: "600"}}>End Time</TableCell>
                    <TableCell sx={{fontFamily: "Montserrat", fontWeight: "600"}}>Total Hours</TableCell>
                  </TableRow>
                  </TableHead>
                  <TableBody>
                    {employeeData.map((entry, idx) => (
                      <TableRow key={idx}>
                        <TableCell scope="row" sx={{fontFamily: "Montserrat", fontWeight: "600"}}>
                          {entry.Date}
                        </TableCell>
                        <TableCell>{entry.StartTime}</TableCell>
                        <TableCell>{entry.BreakTime}</TableCell>
                        <TableCell>{entry.EndTime}</TableCell>
                        <TableCell>{entry.TotalHours}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  </Table>
              </TableContainer>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
      </TableContainer>
    </>
  );
}
